import { Navigate, RouteProps } from "react-router-dom";
import { LoginPage } from "../../../../pages/LoginPage/LoginPage";
import { ResetPasswordPage } from "../../../../pages/ResetPasswordPage/ResetPasswordPage";


export enum AppModalRoutes {
  PRIVACY_POLICY = 'privacy_policy',
}

export const ModalRoutePath = {
  [AppModalRoutes.PRIVACY_POLICY]: '/login/privacy-policy',
};

// Перечисление для имен маршрутов
export enum AppRoutes {
    ROOT = 'root',
    LOGIN = 'login',
    RESET_PASSWORD = 'reset_password',
    NOT_FOUND = 'not_found',
}

// Маппинг путей для маршрутов
export const RoutePath: Record<AppRoutes, string> = {
    [AppRoutes.ROOT]: '/',
    [AppRoutes.LOGIN]: '/login',
    [AppRoutes.RESET_PASSWORD]: '/reset-password',
    [AppRoutes.NOT_FOUND]: '*',
};

// Конфигурация маршрутов
export const routeConfig: Record<AppRoutes, RouteProps> = {
    [AppRoutes.ROOT]: {
        path: '/',
        element: <Navigate to={RoutePath.login} replace />, // Перенаправление на /main
    },
    [AppRoutes.LOGIN]: {
        path: RoutePath.login,
        element: <LoginPage />,
    },
    [AppRoutes.RESET_PASSWORD]: {
        path: RoutePath.reset_password,
        element: <ResetPasswordPage />,
    },
    [AppRoutes.NOT_FOUND]: {
        path: RoutePath.not_found,
        element: <Navigate to={RoutePath.login} replace />,
    },
};

